import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { FileText, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";

export default function TermsUpdateNotice() {
  const [needs, setNeeds] = useState(false);
  const [later, setLater] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/legal/terms-status").then(({ data }) => setNeeds(data.needs_accept)).catch(() => {});
  }, []);

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/legal/terms-accept");
      setNeeds(false);
      toast.success("Grazie, hai accettato i nuovi Termini");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Operazione non riuscita");
    } finally { setBusy(false); }
  };

  if (!needs || later) return null;
  return (
    <div data-testid="terms-update-notice" className="mb-6 rounded-xl border border-indigo-200 bg-indigo-50 p-4 flex flex-col sm:flex-row sm:items-center gap-3">
      <FileText style={{ width: 20, height: 20 }} className="text-indigo-600 shrink-0" />
      <p className="flex-1 text-sm text-indigo-950">
        Abbiamo aggiornato i <Link to="/terms" target="_blank" data-testid="terms-update-link" className="font-semibold underline">Termini e Condizioni</Link>.
        Leggili e conferma di accettarli per continuare a usare MyQuoteFlow.
      </p>
      <div className="flex gap-2 shrink-0">
        <Button size="sm" variant="ghost" data-testid="terms-update-later-btn" onClick={() => setLater(true)}>Più tardi</Button>
        <Button size="sm" data-testid="terms-update-accept-btn" onClick={accept} disabled={busy}>
          {busy && <Loader2 className="w-4 h-4 animate-spin mr-1" />}Accetto
        </Button>
      </div>
    </div>
  );
}
